export default (props) => {
	return {
		...props,
		split: parseInt(props.split, 10),
	};
};
